import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorStateMatcher } from '@angular/material/core';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Ordered } from '../models/ordered';
import { RefundDialogComponent } from './dialogs/refund-dialog/refund-dialog.component';
import { OrderedService } from '../services/ordered.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { FormGroup, FormGroupDirective, FormControl, NgForm } from '@angular/forms';
import { ProductService } from '../services/product.service';
import { Member } from '../models/member';
import { MemberService } from '../services/member.service';
import { TaxService } from '../services/tax.service';
import { Tax } from '../models/tax';
import { Product } from '../models/product';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { OrderRefund } from '../models/refund';
import { RefundService } from '../services/refund.service';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';
import {FileService} from '../services/file.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.scss'],
  entryComponents: [
    RefundDialogComponent
  ]
})
export class RefundComponent implements OnInit {

  /*name of the excel-file which will be downloaded. */
  fileName = 'ExcelSheet.xlsx';

  private subMembers: Subscription;
  private subOrders: Subscription;

  public displayedOrderColumns: string[] = ['icon', 'member_name', 'total', 'edit'];

  public displayedColumns: string[] = ['icon', 'dateRequest', 'dateRefund', 'member_name', 'tid', 'bank', 'total', 'refund', 'edit'];

  public matcher = new FormErrorStateMatcher();
  public intervalForm: FormGroup;

  public arrayMembers: Member[] = []
  public arrayTaxs: Tax[] = []

  public arrayProducts: Product[] = []

  public selectedProduct: any = {};
  public local_title: string = 'Inscrições'

  public ngFlag: boolean = false;
  public failFlag: boolean = false;

  public arrayOrders: Ordered[] = [];
  public orderedDataSource: MatTableDataSource<any>;
  public totalOrdered: number = 0;
  public totalOrdered_minus_tax: number = 0;
  public countOrdered: number = 0;


  public arrayOrdersRefund: Ordered[] = [];
  public orderedDataSourceRefund: MatTableDataSource<any>;
  public totalOrderedRefund: number = 0;
  public totalOrderedRefund_minus_tax: number = 0;
  public countOrderedRefund: number = 0;

  public arrayOrdersRefundRequest: Ordered[] = [];
  public orderedDataSourceRefundRequest: MatTableDataSource<any>;
  public totalOrderedRefundRequest: number = 0;
  public totalOrderedRefundRequest_minus_tax: number = 0;
  public countOrderedRefundRequest: number = 0;

  constructor(
    private db: AngularFirestore,
    private _memberService: MemberService,
    public _orderedService: OrderedService,
    public _productService: ProductService,
    public _refundService: RefundService,
    public _taxService: TaxService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _fileService: FileService,
    private _adapter: DateAdapter<any>) {

    //  this.loadMembers()
    // this.loadTaxs()
    this.loadProducts()
  }

  @ViewChild('paginator', { read: MatPaginator, static: true }) paginator: MatPaginator;
  @ViewChild('paginatorRefund', { read: MatPaginator, static: true }) paginatorRefund: MatPaginator;
  @ViewChild('paginatorRefundRequest', { read: MatPaginator, static: true }) paginatorRefundRequest: MatPaginator;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this._adapter.setLocale('pt');
    this.intervalForm = this._orderedService.createIntervalForm()
    this._orderedService.loadCieloCodes();

  }


  ngOnDestroy() {
    if (this.subMembers)
      this.subMembers.unsubscribe();
    if (this.subOrders)
      this.subOrders.unsubscribe();
  }

  openDialog(entity) {

    let data: Ordered = new Ordered();

    if (entity) {
      data = entity;
    }

    this.dialog.open(RefundDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: { 'product': this.selectedProduct, 'ordered': data }
    });
  }


  openRefundDialog(entity, done) {

    let orderRefund: OrderRefund = new OrderRefund()

    orderRefund.order_id = entity.id
    orderRefund.account = entity.refund.account;
    orderRefund.agency = entity.refund.agency;
    orderRefund.bank = entity.refund.bank;
    orderRefund.bankName = entity.refund.bankName;
    orderRefund.dateRequest = entity.refund.dateRequest;
    orderRefund.dateRefund = entity.refund.dateRefund;
    orderRefund.discount = entity.refund.discount;
    orderRefund.total = entity.refund.total;

    this.dialog.open(RefundDialogComponent, {
      width: '750px',
      height: '530px',
      panelClass: 'custom-dialog-container',
      data: { 'done': done, 'orderRefund': orderRefund }
    });

  }


  selectOrdersByProduct(event) {

    let prod = this.arrayProducts.find((e) => {
      return e.id == event
    })
    this.selectedProduct = prod

    this.subOrders = this._orderedService.loadOrdered(prod.id)
      .subscribe((result) => {

        this.arrayOrders = []
        this.totalOrdered = 0;
        this.totalOrdered_minus_tax = 0;
        this.countOrdered = 0;

        this.arrayOrdersRefund = []
        this.totalOrderedRefund = 0;
        this.totalOrderedRefund_minus_tax = 0;
        this.countOrderedRefund = 0;

        this.arrayOrdersRefundRequest = []
        this.totalOrderedRefundRequest = 0;
        this.totalOrderedRefundRequest_minus_tax = 0;
        this.countOrderedRefundRequest = 0;

        result.forEach((item) => {
          if (item.payload.doc.data().returnCode == "00") {

            this.arrayOrders.push(this._orderedService.createOrderObj(item))

            this.totalOrdered += Number(item.payload.doc.data().total)
            this.totalOrdered_minus_tax += Number(item.payload.doc.data().total_minus_tax)
            this.countOrdered += 1

          } else if (item.payload.doc.data().returnCode == "refund") {

            this.arrayOrdersRefund.push(this._refundService.createRefundObj(item))

            this.totalOrderedRefund += Number(item.payload.doc.data().refund.total)
            this.totalOrderedRefund_minus_tax += Number(item.payload.doc.data().total_minus_tax)
            this.countOrderedRefund += 1

          } else if (item.payload.doc.data().returnCode == "refundrequest") {

            this.arrayOrdersRefundRequest.push(this._orderedService.createOrderObj(item))

            this.totalOrderedRefundRequest += Number(item.payload.doc.data().refund.total)
            this.totalOrderedRefundRequest_minus_tax += Number(item.payload.doc.data().total_minus_tax)
            this.countOrderedRefundRequest += 1

          }
        })

        this.arrayOrders.sort(this.compareNames)

        this.orderedDataSource = new MatTableDataSource(this.arrayOrders)
        this.orderedDataSource.sort = this.sort;
        this.orderedDataSource.paginator = this.paginator;

        this.orderedDataSourceRefund = new MatTableDataSource(this.arrayOrdersRefund)
        this.orderedDataSourceRefund.sort = this.sort;
        this.orderedDataSourceRefund.paginator = this.paginatorRefund;

        this.orderedDataSourceRefundRequest = new MatTableDataSource(this.arrayOrdersRefundRequest)
        this.orderedDataSourceRefundRequest.sort = this.sort;
        this.orderedDataSourceRefundRequest.paginator = this.paginatorRefundRequest;

      })

    this.ngFlag = true;

  }

  compareNames(a: any, b: any) {

    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }


  refreshOrdersByProduct() {
    this.selectOrdersByProduct(this.selectedProduct.id)
  }

  exportSolicitacoesToCsv() {

    const data = this.arrayOrdersRefund

    let csvFile: any[] = []

    csvFile.push("" + ";" + this.selectedProduct.name + '\r\n')

    let csvHeader: string;

    csvHeader = "" + ";"
    csvHeader += 'Solicitação' + ';'
    csvHeader += 'Pagamento' + ';'
    csvHeader += 'Nome' + ';'
    csvHeader += 'Origem' + ';'
    csvHeader += 'Tid' + ';'
    csvHeader += 'Banco' + ';'
    csvHeader += 'Agencia' + ';'
    csvHeader += 'Conta' + ';'
    csvHeader += 'Total' + ';'
    csvHeader += '%' + ';'
    csvHeader += 'Reembolso' + '\r\n'

    csvFile.push(csvHeader)

    //  let countLine:number = 1;
    data.forEach((line) => {

      let dt: any = line.refund.dateRequest

      let dt_solicitacao = new Date(dt.seconds * 1000)
      let dt_solicitacao_formated = this.formatDate(dt_solicitacao)

      dt = line.refund.dateRefund
      let dt_refund = new Date(dt.seconds * 1000)
      let dt_refund_formated = this.formatDate(dt_refund)


      let member: any = this.arrayMembers.find((e) => {
        return line.member_id == e.id
      })

      let total = line.total.toString().replace(".", ",")
      let total_minus_tax = line.total_minus_tax.toString().replace(".", ",")
      let discount = line.discount.toString().replace(".", ",")
      let tid = line.Tid ? line.Tid : 0;

      let tax: any = line.tax

      let member_debit = line.member_debit.toString().replace(".", ",")
      let value = line.value.toString().replace(".", ",")



      let csvLine = ""

      csvLine += "" + ";"
      csvLine += dt_solicitacao_formated + ";"
      csvLine += dt_refund_formated + ";"
      csvLine += line.member_name + ";"
      csvLine += line.origin + ";"
      csvLine += tid + ";"
      csvLine += line.refund.bank + ";"
      csvLine += line.refund.agency + ";"
      csvLine += line.refund.account + ";"
      csvLine += line.refund.discont + ";"
      csvLine += line.refund.total + ";"
      csvLine += line.refund.creditcard + ";"
      csvFile.push(csvLine)
    })


    var BOM = "\uFEFF";
    let csvData = BOM + csvFile;

    var blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    this._fileService.saveFile(blob, "reembolso_solicitacoes.csv");

  }

  formatDate(date: Date) {
    if (date) {
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

  loadMembers() {

    this.subMembers = this._memberService.select()
      .subscribe((result) => {
        this.arrayMembers = result.map(item => {
          let entity = new Member();
          entity.id = item.payload.doc.id,
            entity.name = item.payload.doc.data().name;
          entity.category = item.payload.doc.data().category;
          entity.city = item.payload.doc.data().city;
          entity.state = item.payload.doc.data().state;
          entity.email = item.payload.doc.data().email;
          entity.cpf = item.payload.doc.data().cpf;
          entity.cellPhone = item.payload.doc.data().cellPhone;
          return entity;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }

  loadTaxs() {

    this.subMembers = this._taxService.select()
      .subscribe((result) => {

        this.arrayTaxs = result.map(item => {
          let entity = new Tax();
          entity.id = item.payload.doc.id,
            entity.name = item.payload.doc.data().name;
          entity.value = Number(item.payload.doc.data().value);
          return entity;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }

  loadProducts() {

    return this.db.collection<Product>('sbccv_products', ref => ref
      .orderBy('name', 'asc')).snapshotChanges()
      .subscribe((result) => {

        result.forEach((item) => {
          //  if (item.payload.doc.data().active) {

          let product = new Product();
          product.id = item.payload.doc.id;
          product.name = item.payload.doc.data().name;
          product.text = item.payload.doc.data().text;
          product.image = item.payload.doc.data().image;
          product.active = item.payload.doc.data().active;
          this.arrayProducts.push(product)
          //   }
        })

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })
  }

  RequestRefund(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.member_name + "<br><br>Solicitar Reembolso?" }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {

        this._refundService.selectByProductId(element.product_id)
          .subscribe((result) => {

            if (result[0]) {

              let dt: any = result[0].payload.doc.data().date
              let date_limit = new Date(dt.seconds * 1000)

              if (date_limit >= new Date()) {
                let order_id = element.id
                let total = Number(element.total)
                let percent = Number(result[0].payload.doc.data().percent)
                let value = (total * percent) / 100

                console.log('order_id: ' + order_id)
                console.log('percent: ' + percent)
                console.log('value: ' + value)

                this._orderedService.requestRefund(order_id, percent, value)
                  .then(() => {
                    this.snackBar.openSnackBar("Reembolso solicitado!", '', 'success');
                  })
                  .catch(() => {
                    this.snackBar.openSnackBar("Erro ao solicitar reembolso!", '', 'error');
                  })

              } else {
                this.snackBar.openSnackBar("Solicitação fora do prazo!", '', 'error');
              }

            } else {
              this.snackBar.openSnackBar("Sem Regra de Reembolso!", '', 'error');
            }

          })
      }

    })

  }

}




